import React from "react";
import "./NoContent.css";

export default function NoContent() {
  return (
    <div>
      <p className="no-content">We couldn&#39;t find anything :(</p>
    </div>
  );
}
